import { render } from "./ReplyList.vue?vue&type=template&id=3bc2491f"
import script from "./ReplyList.vue?vue&type=script&lang=js"
export * from "./ReplyList.vue?vue&type=script&lang=js"

import "./ReplyList.vue?vue&type=style&index=0&id=3bc2491f&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__